<template>
  <!-- 首页 -->
  <!-- <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
    :right-bg="rightBg" :partition="[8, 3]" bottom="-100px" direction="flex-end" /> -->
  <div class="contents section-hero" :style="{ backgroundImage: 'url(' + bg + ')', backgroundSize: 'cover' }">
    <div class="container row">
      <div class="col-6">
        <div class="mb-9 pr-2 pl-2">
          <h1 class="fw_900 ">{{ title }}</h1>
          <h1 class="fw_900 mt-2 c_233dd2">{{ subtitle }}</h1>
          <div class="mt-5">
            <p class="mb-2 fw_900">{{ $t('home.description1') }}
            </p>
             <p class="mb-2 fw_900">{{ $t('home.description2') }} <span class="c_233dd2">2000+</span>{{ $t('home.description3') }}
              <span class="c_233dd2">100+</span>{{ $t('home.description4') }}
            </p>
          </div>
          <button type="button" class="btn btn-outline-success mt-5">{{ buttonText }}</button>
        </div>
      </div>
      <!-- <div class="col-6" :style="{ justifyContent: 'flex-end' }" v-if="rightBg">
        <div :style="{ position: 'relative', bottom: '0px' }" class="img_box">
          <img :src="rightBg" alt="" :class="rightBg2 ? `img_box_1` : 'img-fluid'" />
          <img v-if="rightBg2" :src="rightBg2" class="img_box_2" />
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import subPage from './components/SubPage.vue'
export default {
  name: "home",
  components: {
    subPage
  },
  data() {
    return {
      // title: "首页",
      // subtitle: "这是一个副标题",
      // description: ["这是一个描述"],
      // buttonText: "立即开通",
      bg: "/img/pay/0--98.png",
      // rightBg: "/img/pay/0--99.png",
      // rightBg2: "/img/pay/0--31.png",
    }
  },
  computed: {
    title() {
      return this.$t("home.title")
    },
    subtitle() {
      return this.$t("home.subtitle")
    },
    description() {
      return [this.$t("home.description1"), this.$t("home.description2")]
    },
    buttonText() {
      return this.$t("common.buttonText")
    }
  }
};
</script>

<style lang="scss" scoped>
.contents {
  // height: calc(var(--main-height) / 3);
  height: var(--main-height);
  overflow: hidden;
  // background-image: url('/img/pay/0-_BG-5.png');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    height: 100%;
    display: flex;
    // flex-direction: column;

    >div {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .img_box {
      text-align: right;
      // display: flex;
      .img_box_1 {
        width: 50%;
        // padding: 15px;
      }

      .img_box_2 {
        width: 35%;
        padding: 15px;
      }

    }
  }
}

.fw_900 {
  font-weight: 900;
}

.c_233dd2 {
  color: #233dd2;
}
</style>
